import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  GetAcknowledgementById,
  SetAcknowledgement,
  UpdateAcknowledgement,
} from "../../../../Redux/Reducers/Submitter/Acknowledgement";
import loadConfig from "../../../../Services/Api/ApiServices";
import SharedDiv from "../../../../Components/SharedDiv/SharedDiv";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";

function PledgeAndAcknowledgement(props) {
  const AppGuid = useParams();
  //   const [pledgeText, setPledgeText] = useState("");
  const [jsonFile, setJsonFile] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      // ApplicationInformation:
      //   state.ApplicationInformation.ApplicationInformation,
      Acknowledgement: state.Acknowledgement.Acknowledgement,
      loadingAcknowledgement: state.loadingAcknowledgement,
      // ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });
  const [checked, setchecked] = useState({ ...state.Acknowledgement });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    setJsonFile(jsonData);
  };
  useEffect(() => {
    dataJson();
  }, []);

  useEffect(() => {
    dispatch(
      GetAcknowledgementById(
        localStorage.getItem("ApplicationInformationId") ||
        props.applicationGuid

      )
    );
  }, []);

  //[,]
  //to asssigin data after loading end
  useEffect(() => {
    if (!state.loadingAcknowledgement) {
      if (state.loadingAcknowledgement && state.Acknowledgement) {
        setchecked({ ...state.Acknowledgement });
      }
    }
  }, [state.loadingAcknowledgement, state.Acknowledgement]);

  useEffect(() => {
    dispatch(SetAcknowledgement({ ...checked }));
  }, [checked]);
  // const shouldDisableFields =!(
  //[,]
  // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال
  // state.ActiveRound ==
  //       state.ApplicationInformation?.aI_RoundYearId &&
  //     state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //     window.location.href.includes("manager") == false);
  console.log(state.Acknowledgement, "state.Acknowledgement", checked);

  return jsonFile && state.Acknowledgement && !state.loadingAcknowledgement ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="تعهد واقرار"
        child={[
          <div className="checkbox-container" key="checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                disabled={props.shouldDisableFields}
                className="checkbox-input"
                checked={state.Acknowledgement?.acknowledgementStatus}
                onChange={async (e) => {
                  setchecked({
                    acknowledgmentId: state.Acknowledgement?.acknowledgmentId,
                    acknowledgementStatus: e.target.checked,
                    applicationInformationId:
                      state.Acknowledgement?.applicationInformationId,
                  });
                  console.log(e.target.checked, "e.target.checked");
                  // {
                  //   acknowledgmentId: state.Acknowledgement?.acknowledgmentId,
                  //   acknowledgementStatus: e.target.checked,
                  //   applicationInformationId:
                  //   localStorage.getItem("ApplicationInformationId") ||
                  //   decryptToken(AppGuid.AppGuid),
                  // }
                  await dispatch(
                    UpdateAcknowledgement({
                      acknowledgmentId: state.Acknowledgement?.acknowledgmentId,
                      acknowledgementStatus: e.target.checked,
                      applicationInformationId: localStorage.getItem("ApplicationInformationId") ||decryptToken(AppGuid.AppGuid)
                    })
                  );
                }}
                // disabled={shouldDisableFields}
              />
              {jsonFile.pledgeText}
            </label>
          </div>,
        ]}
      />
    </>
  ) : (
    ""
  );
}

export default PledgeAndAcknowledgement;
